// 打印
export function log (msg) {
  console.group('Error [@edu-fe/pay]')
  console.log(`%c${msg}`, 'color: #f00')
  console.groupEnd()
  // window.alert(msg)
}

// 检查是否有值(粗检查)
export function invariant (condition, errMsg) {
  if (!condition) {
    return log(errMsg)
  }
  return true
}

// 提取大 json 中的某几个值组成小 json
export function pick (json, keys) {
  return keys.reduce((result, key) => {
    if (json[key]) {
      result[key] = json[key]
    }
    return result
  }, {})
}

// 给 json 添加默认值
export function appendDefault (target, key, defaultValue) {
  if (typeof target[key] === 'undefined') {
    target[key] = defaultValue
  }
}

// 存储 key
const orderIdStorageName = '@edu-fe/pay temporary orderId'

// 保存 orderId
export function saveOrderId (orderId) {
  window.localStorage.setItem(orderIdStorageName, orderId)
}

// 提取 orderId
export function drawSavedOrderId () {
  return window.localStorage.getItem(orderIdStorageName)
}

// 移除 orderId
export function removeSavedOrderId () {
  window.localStorage.removeItem(orderIdStorageName)
}
